import WYSIWYG from '@components/ui/WYSIWYG'
import config from '@config/seo_meta.json'
import Image from 'next/legacy/image'

interface Props {
  slice: any
}

const ColourPdpBenefitsIcons = ({ slice }: Props) => {
  const gridCols =
    slice?.items.length >= 5
      ? 'md:grid-cols-5 grid-cols-2 '
      : `md:grid-cols-${slice?.items?.length} grid-cols-2 `
  return (
    <div className="w-full bg-brand-light-grey">
      <div className="wrapper py-5 lg:py-16">
        <div className={`grid gap-x-8 gap-y-10 md:gap-y-32 ${gridCols}`}>
          {slice?.items?.map((item: any, index: number) => {
            const ImageUrl = item?.icons?.url
            const description = item?.icons?.alt
            const title = item?.title
            const text = item?.text
            if (ImageUrl) {
              return (
                <div key={index} className="flex flex-col items-center">
                  <div className="w-36">
                    <div className="flex w-full items-center justify-start md:justify-center">
                      {ImageUrl && (
                        <Image
                          src={ImageUrl}
                          alt={description || config.openGraph.images[0].alt}
                          width={48}
                          height={48}
                        />
                      )}
                    </div>
                    {title && (
                      <div className="mt-5 flex justify-start text-left text-body1 text-brand-dark-grey md:justify-center md:text-center">
                        <WYSIWYG content={title} />
                      </div>
                    )}
                    {text && (
                      <div className="mt-2 flex justify-start text-left text-body2 text-brand-dark-grey md:justify-center md:text-center">
                        <WYSIWYG content={text} />
                      </div>
                    )}
                  </div>
                </div>
              )
            }
          })}
        </div>
      </div>
    </div>
  )
}

export default ColourPdpBenefitsIcons
